import { i18n } from '@/locale/i18n'
import InfoIcon from '@/assets/icons/info'
import OverlayPanel from '@/components/OverlayPanel/OverlayPanel'

export { BET_TABLE_CLASS } from '@/pages/portfolio/my-bets/bet-row/betTable'

const HeaderCell = ({ children, className = '' }) => (
  <td className={`py-4 px-3 ${className}`}>
    <div className="flex items-center gap-2 w-fit">{children}</div>
  </td>
)

/* The market page's own column set: it sits next to a market the reader already has open,
   so it leads with the outcome instead of the Portfolio's market title and close date.
   Keep in step with ActiveBetRow's `inMarketPage` branch. */
export const BetListActiveTableHeaders = ({ orderBookEnabled = false }) => (
  <thead className="bet-table-header">
    <tr>
      <HeaderCell>{i18n('bet.outcome')}</HeaderCell>
      <HeaderCell className="w-[180px]">{i18n('bet.paid')}</HeaderCell>
      <HeaderCell className="w-[180px]">
        {i18n('bet.sell_for')}
        {orderBookEnabled && (
          <OverlayPanel
            content={
              <span className="block normal-case text-[length:var(--typography-label-md-size)] leading-[var(--typography-label-md-line-height)] font-[number:var(--typography-label-md-regular-weight)]">
                {i18n('bet.selling_desclaimer')}
              </span>
            }
            position="top-middle-up-middle"
            containerClassName="!flex items-center justify-center !w-[16px]"
            showDelay={50}
            hideDelay={50}
            showMode="hover"
            style={{ width: '200px' }}
            isOverlayEnabled={true}>
            <InfoIcon width="16px" className="block cursor-pointer" />
          </OverlayPanel>
        )}
      </HeaderCell>
      <HeaderCell className="w-[180px]">{i18n('bet.to_win')}</HeaderCell>
      {/* Hugs the Sell button: 86.55px button + 12px cell left padding (rows use !pr-0).
          Must stay a plain td — display:flex here detaches it from the table layout and
          the column falls back to auto width, swallowing the leftover space. */}
      <td className="w-[99px]"></td>
    </tr>
  </thead>
)

export const BetListOrdersTableHeaders = () => (
  <thead className="bet-table-header">
    <tr>
      <HeaderCell>{i18n('bet.outcome')}</HeaderCell>
      <HeaderCell className="w-[77px]">{i18n('bet.price')}</HeaderCell>
      <HeaderCell className="w-[120px]">{i18n('bet.expiration')}</HeaderCell>
      <HeaderCell className="w-[120px]">{i18n('bet.total')}</HeaderCell>
      <HeaderCell className="w-[120px]">{i18n('bet.trade')}</HeaderCell>
      {/* The Cancel column is deliberately unlabelled; the button says what it does.
          Width covers the button plus the row's 16px right gutter. */}
      <td className="w-[120px]"></td>
    </tr>
  </thead>
)
